import easyCheckApi from '../api/config';

const DEFAULT_PREFERENCES = {
  includeAcPayee: true,
  includeAmountPrefix: true,
  includeAmountSuffix: false,
  includeBeneficiary: true,
  includeBeneficiary2: false,
  includeRemarks: false,
  includeDate: true,
  includeAmount: true,
  includeNonNegotiable: false,
  chequeSizedPdf: false,
  excludeCurrencyWords: false,
  enableChequeCollection: false,
  enableSignedStatus: false,
  enableUserPermissions: false,
  enableBankBackup: false,
  enableVoucherPrinting: false,
  enablePdcAlerts: false,
  pdcAlertDays1: 0,
  pdcAlertDays2: 0,
  pdcAlertDays3: 0,
};

const normalizePreferences = (data) => {
  if (!data) return { ...DEFAULT_PREFERENCES };
  return {
    includeAcPayee: data.IncludeAcPayee ?? data.includeAcPayee ?? DEFAULT_PREFERENCES.includeAcPayee,
    includeAmountPrefix: data.IncludeAmountPrefix ?? data.includeAmountPrefix ?? DEFAULT_PREFERENCES.includeAmountPrefix,
    includeAmountSuffix: data.IncludeAmountSuffix ?? data.includeAmountSuffix ?? DEFAULT_PREFERENCES.includeAmountSuffix,
    includeBeneficiary: data.IncludeBeneficiary ?? data.includeBeneficiary ?? DEFAULT_PREFERENCES.includeBeneficiary,
    includeBeneficiary2: data.IncludeBeneficiary2 ?? data.includeBeneficiary2 ?? DEFAULT_PREFERENCES.includeBeneficiary2,
    includeRemarks: data.IncludeRemarks ?? data.includeRemarks ?? DEFAULT_PREFERENCES.includeRemarks,
    includeDate: data.IncludeDate ?? data.includeDate ?? DEFAULT_PREFERENCES.includeDate,
    includeAmount: data.IncludeAmount ?? data.includeAmount ?? DEFAULT_PREFERENCES.includeAmount,
    includeNonNegotiable: data.IncludeNonNegotiable ?? data.includeNonNegotiable ?? DEFAULT_PREFERENCES.includeNonNegotiable,
    chequeSizedPdf: data.ChequeSizedPdf ?? data.chequeSizedPdf ?? DEFAULT_PREFERENCES.chequeSizedPdf,
    excludeCurrencyWords: data.ExcludeCurrencyWords ?? data.excludeCurrencyWords ?? DEFAULT_PREFERENCES.excludeCurrencyWords,
    enableChequeCollection: data.EnableChequeCollection ?? data.enableChequeCollection ?? DEFAULT_PREFERENCES.enableChequeCollection,
    enableSignedStatus: data.EnableSignedStatus ?? data.enableSignedStatus ?? DEFAULT_PREFERENCES.enableSignedStatus,
    enableUserPermissions: data.EnableUserPermissions ?? data.enableUserPermissions ?? DEFAULT_PREFERENCES.enableUserPermissions,
    enableBankBackup: data.EnableBankBackup ?? data.enableBankBackup ?? DEFAULT_PREFERENCES.enableBankBackup,
    enableVoucherPrinting: data.EnableVoucherPrinting ?? data.enableVoucherPrinting ?? DEFAULT_PREFERENCES.enableVoucherPrinting,
    enablePdcAlerts: data.EnablePdcAlerts ?? data.enablePdcAlerts ?? DEFAULT_PREFERENCES.enablePdcAlerts,
    pdcAlertDays1: data.PdcAlertDays1 ?? data.pdcAlertDays1 ?? DEFAULT_PREFERENCES.pdcAlertDays1,
    pdcAlertDays2: data.PdcAlertDays2 ?? data.pdcAlertDays2 ?? DEFAULT_PREFERENCES.pdcAlertDays2,
    pdcAlertDays3: data.PdcAlertDays3 ?? data.pdcAlertDays3 ?? DEFAULT_PREFERENCES.pdcAlertDays3,
  };
};

export const companyPreferencesService = {
  getPreferences: async () => {
    try {
      const response = await easyCheckApi.get('/companypreferences');
      const responseData = response.data;
      const data = responseData.Data || responseData.data || responseData;
      return {
        success: true,
        data: normalizePreferences(data),
      };
    } catch (error) {
      if (error.response?.status === 404) {
        return {
          success: true,
          data: { ...DEFAULT_PREFERENCES },
        };
      }
      console.error('Failed to fetch company preferences:', error);
      return {
        success: true,
        data: { ...DEFAULT_PREFERENCES },
      };
    }
  },

  savePreferences: async (preferences) => {
    try {
      const response = await easyCheckApi.put('/companypreferences', preferences);
      const responseData = response.data;
      if (responseData.Success || responseData.success) {
        const data = responseData.Data || responseData.data || responseData;
        return {
          success: true,
          data: normalizePreferences(data),
          message: responseData.Message || responseData.message || 'Preferences saved successfully',
        };
      }
      return {
        success: false,
        message: responseData.Message || responseData.message || 'Failed to save preferences',
      };
    } catch (error) {
      console.error('Failed to save company preferences:', error);
      const message = error.response?.data?.Message || error.response?.data?.message || 'Failed to save preferences. The backend may not be deployed yet.';
      return {
        success: false,
        message,
      };
    }
  },

  getDefaultPreferences: () => ({ ...DEFAULT_PREFERENCES }),
};

export default companyPreferencesService;
